import { useState, useCallback } from 'react';
import { Editor } from '@tiptap/core';
import { MenuDivider } from '@fluentui/react-components';

import { ETiptapSelectorKey } from '../../../../types/tiptap.types';
import ToolbarMenuItem from '../ToolbarMenuItem';
import { SingleFieldDialog, type TSingleFieldDialogState } from '@shared/components';
import {
  OL_PATTERNS,
  OL_PATTERN_PREVIEW,
  DEFAULT_OL_PATTERN,
  type TOlPattern,
} from '../../../../tiptap/extensions/listPatterns';
import ListSplitButton from './ListSplitButton';

const PATTERN_ITEMS = OL_PATTERNS.map((id) => ({ id, markers: OL_PATTERN_PREVIEW[id] }));

const NUMBERED_LIST_ICON = (
  <svg height="100%" width="100%" viewBox="0,0,2048,2048" focusable="false">
    <path
      type="path"
      style={{ fill: 'transparent' }}
      d="M463 2q22 5 35 22 14 17 14 40v384q0 27-19 45-19 19-45 19-27 0-45-19-19-19-19-45v-217q-20 13-41 21-25 10-49-1-24-11-34-36-10-25 1-49 11-24 36-34 32-13 66-55 12-15 21-31 3-5 6-9l1-2 0 0q10-20 31-29 20-9 41-4z m-7 763q-25 0-48 18-24 19-24 42v7q0 27-19 45-19 19-45 19-27 0-45-19-19-19-19-45v-7q0-76 62-133 60-56 138-56 83 0 136 60 51 56 49 132-2 80-65 134l-83 62h83q27 0 45 19 19 19 19 45 0 27-19 45-19 19-45 19h-256q-20 0-37-12-16-11-23-30-7-19-2-38 5-19 20-33l215-174q30-26 16-63-14-37-53-37z m-8 515q-80 0-136 56-56 56-56 136 0 27 19 45 19 19 45 19 27 0 45-19 19-19 19-45 0-27 19-45 19-19 45-19 27 0 45 19 19 19 19 45 0 27-19 45-19 19-45 19-27 0-45 19-19 19-19 45 0 27 19 45 19 19 45 19 27 0 45 19 19 19 19 45 0 27-19 45-19 19-45 19-27 0-45-19-19-19-19-45 0-27-19-45-19-19-45-19-27 0-45 19-19 19-19 45 0 80 56 136 56 56 136 56 80 0 136-56 56-56 56-136 0-73-49-128 49-55 49-128 0-80-56-136-56-56-136-56z m320-960q0-27 19-45 19-19 45-19h1024q27 0 45 19 19 19 19 45 0 27-19 45-19 19-45 19h-1024q-27 0-45-19-19-19-19-45z m0 640q0-27 19-45 19-19 45-19h1024q27 0 45 19 19 19 19 45 0 27-19 45-19 19-45 19h-1024q-27 0-45-19-19-19-19-45z m64 576q-27 0-45 19-19 19-19 45 0 27 19 45 19 19 45 19h1024q27 0 45-19 19-19 19-45 0-27-19-45-19-19-45-19h-1024z"
    ></path>
    <path
      type="path"
      style={{ fill: '#3A3A38FF' }}
      d="M768 320q0-27 19-45 19-19 45-19h1024q27 0 45 19 19 19 19 45 0 27-19 45-19 19-45 19h-1024q-27 0-45-19-19-19-19-45z m0 640q0-27 19-45 19-19 45-19h1024q27 0 45 19 19 19 19 45 0 27-19 45-19 19-45 19h-1024q-27 0-45-19-19-19-19-45z m0 640q0-27 19-45 19-19 45-19h1024q27 0 45 19 19 19 19 45 0 27-19 45-19 19-45 19h-1024q-27 0-45-19-19-19-19-45z"
    ></path>
    <path
      type="path"
      style={{ fill: '#357457' }}
      d="M463 2q22 5 35 22 14 17 14 40v384q0 27-19 45-19 19-45 19-27 0-45-19-19-19-19-45v-217q-20 13-41 21-25 10-49-1-24-11-34-36-10-25 1-49 11-24 36-34 32-13 66-55 12-15 21-31 3-5 6-9l1-2 0 0q10-20 31-29 20-9 41-4z m-7 763q-25 0-48 18-24 19-24 42v7q0 27-19 45-19 19-45 19-27 0-45-19-19-19-19-45v-7q0-76 62-133 60-56 138-56 83 0 136 60 51 56 49 132-2 80-65 134l-83 62h83q27 0 45 19 19 19 19 45 0 27-19 45-19 19-45 19h-256q-20 0-37-12-16-11-23-30-7-19-2-38 5-19 20-33l215-174q30-26 16-63-14-37-53-37z m-200 707q0-80 56-136 56-56 136-56 80 0 136 56 56 56 56 136 0 73-49 128 49 55 49 128 0 80-56 136-56 56-136 56-80 0-136-56-56-56-56-136 0-27 19-45 19-19 45-19 27 0 45 19 19 19 19 45 0 27 19 45 19 19 45 19 27 0 45-19 19-19 19-45 0-27-19-45-19-19-45-19-27 0-45-19-19-19-19-45 0-27 19-45 19-19 45-19 27 0 45-19 19-19 19-45 0-27-19-45-19-19-45-19-27 0-45 19-19 19-19 45 0 27-19 45-19 19-45 19-27 0-45-19-19-19-19-45z"
    ></path>
  </svg>
);

type TProps = {
  editor: Editor;
  menuClasses: { menu: string };
};

const OrderedListButton = ({ editor, menuClasses }: TProps) => {
  const [numDialog, setNumDialog] = useState<TSingleFieldDialogState<'number'> | undefined>(undefined);

  const openNumberDialog = useCallback(() => {
    const attrs = editor.getAttributes(ETiptapSelectorKey.ORDERED_LIST_WITH_START) as { start?: number } | undefined;
    const currentStart = Number(attrs?.start ?? 1);
    const suggested = currentStart > 1 ? currentStart : 2;

    const dialogState: TSingleFieldDialogState<'number'> = {
      isOpen: true,
      inputType: 'number',
      defaultText: suggested,
      title: 'Set numbering value',
      label: 'Start at',
      buttonLabel: 'Apply',
      onSubmit: ({ text }) => {
        const v = Number(text);
        if (Number.isFinite(v) && v >= 1) {
          editor.chain().focus().setOrderedListStart(v).run();
        }
        setNumDialog((prev) => (prev ? { ...prev, isOpen: false } : prev));
      },
    };
    setNumDialog(dialogState);
  }, [editor]);

  return (
    <>
      <ListSplitButton
        menuClasses={menuClasses}
        selector={ETiptapSelectorKey.ORDERED_LIST_WITH_START}
        icon={NUMBERED_LIST_ICON}
        tooltip="Numbering"
        chevronTooltip={{
          active: 'Numbering options',
          inactive: 'Place the cursor in a numbered list to change numbering.',
        }}
        onToggle={() => editor.chain().focus().toggleOrderedListWithResume().run()}
        disabled={(e) => e.isActive(ETiptapSelectorKey.HEADING) || !e.can().chain().focus().toggleOrderedList().run()}
        patterns={PATTERN_ITEMS}
        defaultPattern={DEFAULT_OL_PATTERN}
        onSelectPattern={(pattern) =>
          editor
            .chain()
            .focus()
            .setOrderedListPattern(pattern as TOlPattern | null)
            .run()
        }
        extraMenuItems={
          <>
            <ToolbarMenuItem onClick={() => editor.chain().focus().resumeOrderedList().run()}>
              Continue numbering
            </ToolbarMenuItem>
            <ToolbarMenuItem onClick={() => editor.chain().focus().restartOrderedList().run()}>
              Restart at 1
            </ToolbarMenuItem>
            <ToolbarMenuItem onClick={openNumberDialog}>Set numbering value…</ToolbarMenuItem>
            <MenuDivider />
          </>
        }
      />
      <SingleFieldDialog state={numDialog} setState={setNumDialog} />
    </>
  );
};

export default OrderedListButton;
